import React from 'react'
import Hero from './Hero';
import Body from './Body';
import Deployment from './Deployment';
import Cards from './Cards';
import { Link ,Navigate } from 'react-router-dom';
import { signInWithGoogle } from './firebase';
function Navbar() {




  return (
    <div>
<header className="text-gray-600 body-font  ">
  <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center ">
    <a className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
    <img src='hackscript.png' className='logoimg'></img>
      <span className="ml-3 text-xl">HackScript</span>
    </a>
    <nav className=" md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-400	flex flex-wrap items-center text-base justify-center">
      <a className=" animat  mr-5  text-blue-900  hover:text-gray-900">Events</a>
      <a className=" animatmr-5  text-blue-900  hover:text-gray-900">LeaderBoard</a>
    </nav>

    < a href='https://earnest-starship-32aaae.netlify.app/'>
    <button className=" animated  inline-flex items-center  text-gray-900 bg-gray-100 border-0 py-2.5 rounded-lg  px-3 mfocus:outline-none hover:bg-gray-900 hover:text-gray-100 rounded text-base mt-4 md:mt-0">
Open Console

    </button>
    </a>
    <Link to = "/auth"  className="mx-7 relative px-5 py-3 overflow-hidden font-medium text-gray-600 bg-gray-100 border border-gray-100 rounded-lg shadow-inner group">
<span className="absolute top-0 left-0 w-0 h-0 transition-all duration-200 border-t-2 border-blue-600 group-hover:w-full ease"></span>
<span className="absolute bottom-0 right-0 w-0 h-0 transition-all duration-200 border-b-2 border-gray-600 group-hover:w-full ease"></span>
<span className="absolute top-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-greeny-600 group-hover:h-full ease"></span>
<span className="absolute bottom-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-greeny-600 group-hover:h-full ease"></span>
<span className="absolute inset-0 w-full h-full duration-300 delay-300 bg-green-600 opacity-0 group-hover:opacity-100"></span>
<span className="relative transition-colors duration-300 delay-200 group-hover:text-white ease">Log In </span>
</Link>
  </div>
</header>
<Hero/>
<Body/>

<Deployment/>


    </div>
  )
}

export default Navbar